import styles from "./GalleryList.module.scss";
import React from "react";
import _ from "lodash";

import Gallery from "../../types/Gallery";
import { ActionLink } from "../ActionLink";

export interface GalleryListProps {
    galleries: Gallery[];
}

const GalleryItem = (gallery: Gallery) => {
    const id = _.last(gallery.name.split("/"));
    let label = gallery.display_name;

    if (gallery.isTrial()) {
        label += " (Trial)"
    }

    return (
        <li className={styles["gallery-item"]} key={id}>
            <ActionLink to={'/dashboard/galleries/' + id} className={styles["action-link"]}>
                {label}
            </ActionLink>
        </li>
    );
}


export const GalleryList = (props: GalleryListProps) => {
    return (
        <div>
            <h2>My Galleries</h2>
            <ul className={styles["gallery-list-container"]}>
                {_.map(props.galleries, GalleryItem)}
            </ul>
        </div>
    );
}

export default GalleryList;
